// for add employee

export const RESET_ADD_USER_PERMISSIONS = "reset_add_user_permissions";
export const ADD_USER_PERMISSIONS = "add_user_permissions";
export const ADD_USER_PERMISSIONS_SUCCESS = "add_user_permissions_success";
export const ADD_USER_PERMISSIONS_FAILURE = "add_user_permissions_failure";
